<nav class="navbar navbar-expand-lg navbar-dark bg-dark">
    <a class="navbar-brand" href="#">MasterGym</a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
            <li class="nav-item active">
                <a class="nav-link" routerLink="/">inscripcion <span class="sr-only">(current)</span></a>
            </li>

            <li class="nav-item">
                <a class="nav-link" routerLink="/listado-inscripciones">Ver Inscripciones<span class="sr-only"></span></a>
            </li>

            <li class="nav-item dropdown" dropdown>
                <a class="nav-link dropdown-toggle" dropdownToggle id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Clientes
            </a>
                <div class="dropdown-menu" *dropdownMenu aria-labelledby="navbarDropdown">
                    <a class="dropdown-item" routerLink="/agregar-cliente">Agregar</a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" routerLink="/listado-clientes">Ver Clientes</a>
                </div>
            </li>

            <li class="nav-item">
                <a class="nav-link" routerLink="/precios">Precios<span class="sr-only"></span></a>
            </li>
        </ul>
    </div>

    <button class="btn btn-danger" (click)="logout()">Salir</button>
</nav>